import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { TranslateService } from '../../services/translate.service';
import { DialogButtonComponent } from '../buttons/dialog-button.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoadingSpinnerComponent } from '../ui/loading-spinner-component';
import { ModalService } from '../../services/modal.service';
import {AuthorizedApiService} from '../../services/authorized-api.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, LoadingSpinnerComponent, DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80 relative">
      <div class="p-4">
        <div class="text-xl font-medium">{{translate.getString("Ange Rabattkod")}}</div>
      </div>

      <div class="px-4 pt-6 pb-2 flex flex-col items-center">
        <input
          #discountInput
          [disabled]="sending"
          [(ngModel)]="code"
          [placeholder]="translate.single('Rabattkod', 'upper')"
          type="text"
          (keyup)="onKeyup()"
          (input)="onInput()"
          class="w-40 p-2 border rounded-xl bg-theme-surface2 text-center uppercase focus:outline-none focus:ring-2 ring-theme-primary placeholder-theme-primary-50 font-medium text-lg tracking-wider"
          >
      </div>

      <div class="h-10 px-4 pb-2">
        <div *ngIf="error && !sending" class="text-center">{{translate.getString(errorMessage)}}</div>
      </div>
      <div *ngIf="sending" class="absolute bottom-10 left-0 right-0 w-full">
        <app-loading-spinner *ngIf="sending"></app-loading-spinner>
      </div>

      <div class="px-4 pb-4 flex justify-end">
        <app-dialog-button [text]="translate.getString('Stäng')" (onClick)="close()"></app-dialog-button>
      </div>
    </div>
  `
})

export class EnterDiscountCodeDialogComponent implements OnInit {
  code = "";
  error = false;
  errorMessage: string = "";
  sending = false;
  lastTestedCode?: string;
  @ViewChild('discountInput') discountInput!: ElementRef<HTMLInputElement>;

  receiptKey?: string;
  dialogType?: string;

  constructor(private order: OrderService, public translate: TranslateService,
              private cdr: ChangeDetectorRef, private modalService: ModalService, private api: AuthorizedApiService,
              @Inject('MODAL_DATA') public data: { receiptKey?: string, type?: string }) {
    this.receiptKey = data?.receiptKey;
    this.dialogType = data?.type || 'default';
    console.log("EnterDiscountCodeDialogComponent initialized with receiptKey:", this.receiptKey);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.discountInput.nativeElement.focus();
  }

  onInput(): void {
    this.handleCodeInput();
  }

  onKeyup(): void {
    this.handleCodeInput();
  }

  handleCodeError(err: any) {
    console.log("Error", err);
    this.error = true;
    this.sending = false;
    if (err?.error?.message) {
      switch (err.error.message) {
        case "invalid code":
          this.errorMessage = "Okänd rabattkod angiven";
          break;
        case "not active code":
          this.errorMessage = "Rabattkod utgången eller förbrukad";
          break;
        case "max_users":
          this.errorMessage = "Rabattkod fullt utnyttjad";
          break;
        case "missing_discount":
          this.errorMessage = "Kod har fel rabattprogram";
          break;
        default:
          this.errorMessage = "Okänt fel inträffade";
      }
    } else {
      this.errorMessage = "Ett fel inträffade vid anslutning till servern";
    }
    this.cdr.detectChanges();
  }

  handleCodeInput(): void {
    let code = this.code.toUpperCase();
    if (code.length > 6) {
      code = code.substring(0, 6);
    }
    this.code = code;
    this.error = false;

    if (code.length === 6 && this.lastTestedCode !== code) {
      this.error = false;
      this.sending = true;
      this.lastTestedCode = code;

      if (this.receiptKey || this.dialogType === 'receipt') {
        // If receiptKey exists, use activateDiscountCode
        this.api.activateDiscountCode(code, this.receiptKey!).subscribe(
          (result) => {
            this.error = false;
            this.close(result);
          },
          (err) => {
            this.handleCodeError(err);
          }
        );
      } else {
        // If no receiptKey, use addDiscountCode
        this.order.addDiscountCode(code).subscribe(
          (result) => {
            this.error = false;
            this.close(result);
          },
          (err) => {
            this.handleCodeError(err);
          }
        );
      }

    }
  }

  close(result?: any) {
    this.modalService.close(result);
  }

}
